import type {
    ICaseListResponse,
    ICaseResponse,
    ICreateCase,
    IUpdateCase,
    IListCasesQuery,
    ITrashedCaseListResponse,
    IRestoreCaseResponse,
} from '@escloud/types';

import type { ApiClient } from './api-client';

export class CasesService {
    constructor(private api: ApiClient) {}

    list(query?: IListCasesQuery): Promise<ICaseListResponse> {
        const params = new URLSearchParams();
        if (query?.workflowId) params.append('workflowId', query.workflowId);
        if (query?.jobStatus) params.append('jobStatus', query.jobStatus);
        if (query?.name) params.append('name', query.name);
        if (query?.createdAfter) params.append('createdAfter', query.createdAfter);
        if (query?.createdBefore) params.append('createdBefore', query.createdBefore);
        if (query?.limit !== undefined) params.append('limit', String(query.limit));
        if (query?.offset !== undefined) params.append('offset', String(query.offset));

        const queryString = params.toString();
        const path = queryString ? `/cases?${queryString}` : '/cases';
        return this.api.get<ICaseListResponse>(path);
    }

    getById(id: string): Promise<ICaseResponse> {
        return this.api.get<ICaseResponse>(`/cases/${id}`);
    }

    create(data: ICreateCase): Promise<ICaseResponse> {
        return this.api.post<ICaseResponse>('/cases', data);
    }

    update(id: string, data: IUpdateCase): Promise<ICaseResponse> {
        return this.api.patch<ICaseResponse>(`/cases/${id}`, data);
    }

    delete(id: string): Promise<void> {
        return this.api.delete<void>(`/cases/${id}`);
    }

    // Trash operations
    listTrashed(query?: { limit?: number; offset?: number }): Promise<ITrashedCaseListResponse> {
        const params = new URLSearchParams();
        if (query?.limit !== undefined) params.append('limit', String(query.limit));
        if (query?.offset !== undefined) params.append('offset', String(query.offset));

        const queryString = params.toString();
        const path = queryString ? `/cases/trash?${queryString}` : '/cases/trash';
        return this.api.get<ITrashedCaseListResponse>(path);
    }

    restore(id: string): Promise<IRestoreCaseResponse> {
        return this.api.post<IRestoreCaseResponse>(`/cases/${id}/restore`);
    }

    permanentlyDelete(id: string): Promise<void> {
        return this.api.delete<void>(`/cases/${id}/permanent`);
    }
}
